import axios from "axios";

// Remove all default headers
axios.defaults.headers.common = {};
axios.defaults.headers.get = {};
axios.defaults.headers.post = {};
axios.defaults.headers.put = {};
axios.defaults.headers.delete = {};

// Set ONLY this header globally
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.get["Content-Type"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.delete["Content-Type"] = "application/json";